<p-toast key="newRequestErrors">
    <ng-template let-message pTemplate="message">
        <div>
            <h4> {{ message.summary | translate }} </h4>
            <p> {{ message.detail | translate }} </p>
            <ul *ngIf="message.data">
                <li *ngFor="let data of message.data">
                    <span class="material-symbols-outlined"> warning </span>
                    {{data | translate}}
                </li>
            </ul>
        </div>
    </ng-template>
</p-toast>

<p-toast key="docPackError" />

<p-confirmDialog />

@switch (newRequestStatus.step) {
    @case (1) {
        <app-loading [isLoading]="isLoading" [messages]="waitingMessages">
            <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_DATA" | translate }}</h3>
            <app-inside-disable [isDisabled]="formIsDisabled">
                <form [formGroup]="newInnovationRequestService.myForm" disabled>
                    <div class="grid">

                        <div class="col-4">
                            <label for="_requestType">{{ 'NEW_REQUEST.REQUEST_TYPE' | translate }}</label>
                            <p-select
                                id="_requestType"
                                [options]="requestTypeConfigs"
                                [(ngModel)]="selectedRequestType"
                                [ngModelOptions]="{ standalone: true }"
                                optionValue='id'
                                optionLabel='label'
                                (onChange)="onRequestTypeChange($event)"
                            >
                                <ng-template let-item pTemplate="selectedItem">
                                    <div>
                                        {{ item.label | translate }}
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        {{ option.label | translate }}
                                    </div>
                                </ng-template>
                            </p-select>
                        </div>
                        <!-- *** BELENDER WIDGET LANG *** -->
                        <div class="col-4" *ngIf="newInnovationRequestService.myForm.get('language')">
                            <label for="language">{{ 'NEW_REQUEST.BELENDER_WIDGET_LANG' | translate }}</label>
                            <p-select
                                id="language"
                                [options]="belenderWidgetLangOptions"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="language"
                            >
                                <ng-template let-option pTemplate="selectedItem">
                                    <div>{{ option.label | translate }}</div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>{{ option.label | translate }}</div>
                                </ng-template>
                            </p-select>
                        </div>
                        <!-- <div class="col-4">
                            <label for="_accessType">{{ 'NEW_REQUEST.ACCESS_TYPE' | translate }}</label>
                            <p-dropdown
                                id="_accessType"
                                [options]="availableAccessTypes"
                                [(ngModel)]="selectedAccessType"
                                [ngModelOptions]="{ standalone: true }"
                                optionValue='id'
                                optionLabel='label'
                                (onChange)="onAccessTypeChange($event)"
                            >
                                <ng-template let-item pTemplate="selectedItem">
                                    <div>
                                        {{ item.label | translate }}
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <div>
                                        {{ option.label | translate }}
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div> -->

                        <!-- ========== PERSONA FÍSICA (PhysicalPerson) ========== -->
                        @if (selectedRequestorType === 'PhysicalPerson') {
                            <div class="break-row"></div>

                            <div class="col-4" *ngIf="newInnovationRequestService.myForm.get('firstName')">
                                <label for="_name">{{ "NEW_REQUEST.NAME" | translate }}</label>
                                <input pInputText="_name" id="_name" formControlName="firstName" maxLength="20" />
                            </div>

                            <div class="col-4" *ngIf="newInnovationRequestService.myForm.get('firstSurname')">
                                <label for="_first-surame">{{ "NEW_REQUEST.FIRST_SURNAME" | translate }}</label>
                                <input pInputText="surame" id="surame" formControlName="firstSurname" maxLength="20" />
                            </div>

                            <div class="col-4" *ngIf="newInnovationRequestService.myForm.get('secondSurname')">
                                <label for="_second-surname">{{ "NEW_REQUEST.SECOND_SURNAME" | translate }}</label>
                                <input pInputText="_second-surname" id="_second-surname" formControlName="secondSurname" maxLength="20" />
                            </div>

                            <div class="break-row"></div>

                            <!-- Document Type Dropdown -->
                            <div class="col-3" *ngIf="newInnovationRequestService.myForm.get('personId')">
                                <label for="_documentType">{{ 'IDENTIFICATION_DOCUMENT' | translate }}</label>
                                <p-select
                                    id="_documentType"
                                    [options]="documentTypeOptions"
                                    [(ngModel)]="newInnovationRequestService.selectedDocumentType"
                                    [ngModelOptions]="{ standalone: true }"
                                    optionValue='id'
                                    optionLabel='label'
                                    (onChange)="onDocumentTypeChange($event)"
                                >
                                    <ng-template let-item pTemplate="selectedItem">
                                        <div>
                                            {{ item.label | translate }}
                                        </div>
                                    </ng-template>
                                    <ng-template let-option pTemplate="item">
                                        <div>
                                            {{ option.label | translate }}
                                        </div>
                                    </ng-template>
                                </p-select>
                            </div>

                            <!-- Document Number -->
                            <div class="col-3" *ngIf="newInnovationRequestService.myForm.get('personId')">
                                <label for="_documentNumber">{{ 'NEW_REQUEST.DOCUMENT_NUMBER' | translate }}</label>
                                <input pInputText id="_documentNumber" formControlName="personId" maxLength="9" />
                            </div>

                            <div class="col-3" *ngIf="newInnovationRequestService.myForm.get('phoneNumber')">
                                <label for="_phone">{{ 'NEW_REQUEST.PHONE' | translate }}</label>
                                <input pInputText="_phone" formControlName="phoneNumber" maxLength="9" />
                            </div>
                        }

                        <!-- ========== PERSONA JURÍDICA (LegalPerson) ========== -->
                        @if (selectedRequestorType === 'LegalPerson') {
                            <!-- Sección: Empresa -->
                            <div class="col-12">
                                <h4 class="section-title m-0">{{ 'NEW_REQUEST.COMPANY_SECTION' | translate }}</h4>
                            </div>

                            <div class="col-4">
                                <label for="_companyName">{{ 'NEW_REQUEST.COMPANY_NAME' | translate }}</label>
                                <input pInputText id="_companyName" formControlName="companyName" maxLength="100" />
                            </div>

                            <div class="col-4">
                                <label for="_companyId">{{ 'NEW_REQUEST.TIN' | translate }}</label>
                                <input pInputText id="_companyId" formControlName="companyId" maxLength="9" />
                            </div>

                            <div class="break-row"></div>

                            <!-- Sección: Representante Legal -->
                            <div class="col-12">
                                <h4 class="section-title m-0">{{ 'NEW_REQUEST.LEGAL_REPRESENTATIVE_SECTION' | translate }}</h4>
                            </div>

                            <div class="col-4">
                                <label for="_legalRepName">{{ 'NEW_REQUEST.NAME' | translate }}</label>
                                <input pInputText id="_legalRepName" formControlName="firstName" maxLength="20" />
                            </div>

                            <div class="col-4">
                                <label for="_legalRepFirstSurname">{{ 'NEW_REQUEST.FIRST_SURNAME' | translate }}</label>
                                <input pInputText id="_legalRepFirstSurname" formControlName="firstSurname" maxLength="20" />
                            </div>

                            <div class="col-4">
                                <label for="_legalRepSecondSurname">{{ 'NEW_REQUEST.SECOND_SURNAME' | translate }}</label>
                                <input pInputText id="_legalRepSecondSurname" formControlName="secondSurname" maxLength="20" />
                            </div>

                            <div class="break-row"></div>

                            <div class="col-4">
                                <label for="_legalRepEmail">{{ 'NEW_REQUEST.EMAIL' | translate }}</label>
                                <input pInputText id="_legalRepEmail" formControlName="email" />
                            </div>

                            <div class="col-3">
                                <label for="_legalRepPhone">{{ 'NEW_REQUEST.PHONE' | translate }}</label>
                                <input pInputText id="_legalRepPhone" formControlName="phoneNumber" maxLength="9" />
                            </div>

                            <!--
                            <div class="col-12">
                                <label for="_personIdFrontPhoto">{{ 'NEW_REQUEST.PERSON_ID_FRONT_PHOTO' | translate }}</label>

                                <p-fileUpload
                                    id="_personIdFrontPhoto"
                                    mode="advanced"
                                    [accept]="ACCEPTED_FILE_TYPES"
                                    [maxFileSize]="MAX_FILE_SIZE"
                                    [showUploadButton]="false"
                                    [showCancelButton]="false"
                                    [chooseLabel]="'NEW_REQUEST.SELECT_FILE' | translate"
                                    [invalidFileTypeMessageSummary]="'NEW_REQUEST.INVALID_FILE' | translate"
                                    [invalidFileTypeMessageDetail]="'NEW_REQUEST.INVALID_FILE_TYPE_DETAIL' | translate"
                                    [invalidFileSizeMessageSummary]="'NEW_REQUEST.INVALID_FILE' | translate"
                                    [invalidFileSizeMessageDetail]="'NEW_REQUEST.INVALID_FILE_SIZE_DETAIL' | translate"
                                    [class.ng-invalid]="newInnovationRequestService.myForm.get('personIdFrontPhoto')?.invalid"
                                    [class.ng-dirty]="newInnovationRequestService.myForm.get('personIdFrontPhoto')?.dirty"
                                    (onSelect)="onFileSelect($event, 'personIdFrontPhoto')"
                                    (onRemove)="onFileRemove('personIdFrontPhoto')"
                                >
                                    <ng-template pTemplate="empty">
                                        <div class="center">
                                            <span class="text-sm text-muted">{{ 'NEW_REQUEST.DRAG_AND_DROP' | translate }}</span>
                                        </div>
                                    </ng-template>
                                </p-fileUpload>
                            </div>

                            <div class="col-12">
                                <label for="_personIdBackPhoto">{{ 'NEW_REQUEST.PERSON_ID_BACK_PHOTO' | translate }}</label>

                                <p-fileUpload
                                    id="_personIdBackPhoto"
                                    mode="advanced"
                                    [accept]="ACCEPTED_FILE_TYPES"
                                    [maxFileSize]="MAX_FILE_SIZE"
                                    [showUploadButton]="false"
                                    [showCancelButton]="false"
                                    [chooseLabel]="'NEW_REQUEST.SELECT_FILE' | translate"
                                    [invalidFileTypeMessageSummary]="'NEW_REQUEST.INVALID_FILE' | translate"
                                    [invalidFileTypeMessageDetail]="'NEW_REQUEST.INVALID_FILE_TYPE_DETAIL' | translate"
                                    [invalidFileSizeMessageSummary]="'NEW_REQUEST.INVALID_FILE' | translate"
                                    [invalidFileSizeMessageDetail]="'NEW_REQUEST.INVALID_FILE_SIZE_DETAIL' | translate"
                                    [class.ng-invalid]="newInnovationRequestService.myForm.get('personIdBackPhoto')?.invalid"
                                    [class.ng-dirty]="newInnovationRequestService.myForm.get('personIdBackPhoto')?.dirty"
                                    (onSelect)="onFileSelect($event, 'personIdBackPhoto')"
                                    (onRemove)="onFileRemove('personIdBackPhoto')"
                                >
                                    <ng-template pTemplate="empty">
                                        <div class="center">
                                            <span class="text-sm text-muted">{{ 'NEW_REQUEST.DRAG_AND_DROP' | translate }}</span>
                                        </div>
                                    </ng-template>
                                </p-fileUpload>
                            </div>
                            -->
                        }                        
                    </div>

                    <app-admin-messages #adminMessages [type]="adminMessagesType()" (isOk)="isAdminOk = $event" />

                    <div class="buttons-row">
                        @if (isAdminOk) {
                            <button class="filled-btn" (click)="onSubmit()">{{ 'NEW_REQUEST.CREATE_REQUEST' | translate }}</button>
                        } @else {
                            <button class="filled-btn" (click)="adminMessages.setMessages()">{{ 'NEW_REQUEST.CHECK_STATUS' | translate }}</button>
                        }
                    </div>

                </form>
            </app-inside-disable>
        </app-loading>
    }
    @case (2) {
        <app-loading [isLoading]="isLoadingRequest">
            <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_SUMMARY" | translate }}</h3>
            <app-new-request-summary-fields [fields]="fields" [form]="newInnovationRequestService.myForm" />

            @if (queryResponse.consentUrlBoxed && currentBelenderCircuit !== 6) {
                <div class="center">
                    <app-qr-code [value]="queryResponse.consentUrlBoxed" [showLabel]="true" />
                </div>
            }

            <div class="info-box">
                <span class="material-symbols-outlined"> check_circle </span>
                <p>
                    @if (currentBelenderCircuit === 6) {
                        {{ "NEW_REQUEST.EMAIL_SENT_TO_APPLICANT" | translate }}
                    } @else {
                        {{ "NEW_REQUEST.SMS_SENT_TO_APPLICANT" | translate }}
                    }
                </p>
            </div>

            <div class="buttons-row">
                <button *ngIf="(!isProd())" class="outline-btn" (click)="continueOTP()">
                    {{ (isLegalPersonSelected() ? "REQUEST_DETAIL.CONTINUE_PROCESS" : "REQUEST_DETAIL.CONTINUE_OTP") | translate }}
                </button>
                <button class="filled-btn" (click)="goToDetail()">{{ "NEW_REQUEST.DETAILS" | translate }}</button>
            </div>
        </app-loading>
    }
    @case (3) {
        <app-belender-widget class="widget" [url]="trustedConsentUrl" />

        <!-- <div class="buttons-row" *ngIf="detailButtonIsVisible()">
            <button class="filled-btn" (click)="goToDetail()" [disabled]="!queryResponse && !newInnovationRequestService.isFinishingOTP">
                {{ "NEW_REQUEST.DETAILS" | translate }}
            </button>
        </div> -->
    }
}
